import React, { PropTypes, Component } from 'react';
import { StudentActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import StudentDetail from 'components/Route/Student/Detail';
import { StudentStore, StudentOverviewStore } from 'stores';
import AuthStore from 'stores/Auth';
import Loader from 'components/Material/Loader';

class StudentDetailContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(StudentStore);
    this.listenToStore(AuthStore, 'auth');
  }

  state = {
    lista: 'user'
  };

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    StudentActions.findById(this.props.params.studentId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routeParams.studentId !== nextProps.routeParams.studentId) {
      StudentActions.findById(nextProps.routeParams.studentId);
    }
  }

  render() {
    const { student, auth } = this.state;
    if (!student) {
      return <Loader />;
    }
    return (
      <StudentDetail
        student={student}
        auth={auth}
        list={this.state.lista}
        onClose={this.props.router.goBack}
      />
    );
  }
}

export default StudentDetailContainer;



// WEBPACK FOOTER //
// ./src/js/containers/StudentDetailContainer.js